import React, { useEffect } from "react";
import { CallAPI } from "services/API";
import TableWithContainer from "utils/Table/TableWithContainer";

export default function PremiumsBound(props) {
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const headers = [[ "Policy Type", "Average", "Total" ]];

    const [data, setData] = React.useState([
        ["Overall", currency.format(0), currency.format(0)],
        ["Combo", currency.format(0), currency.format(0)],
        ["Online", currency.format(0), currency.format(0)],
        ["CRC", currency.format(0), currency.format(0)],
        ["Agency", currency.format(0), currency.format(0)]
    ]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", "/Home/GetPremiumsBound", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city
        });

        if (response) {
            const formattedResponse = [
                [
                    "Overall",
                    currency.format(response.avgOverall),
                    currency.format(response.totalOverall)
                ], [
                    "Combo",
                    currency.format(response.avgCombo),
                    currency.format(response.totalCombo)
                ], [
                    "Online",
                    currency.format(response.avgOnline),
                    currency.format(response.totalOnline)
                ], [
                    "CRC",
                    currency.format(response.avgCRC),
                    currency.format(response.totalCRC)
                ], [
                    "Agency",
                    currency.format(response.avgAgency),
                    currency.format(response.totalAgency)
                ]
            ];

            if (props.comments?.length > 0) {
                headers[0].push('');
                formattedResponse.map(x => {
                    let comment = props.comments.find(y => y.row.toLowerCase() == x[0].toLowerCase());
                    x.push(comment ? comment.message : '');
                });
            }

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);
    
    return (
        <div>
            <TableWithContainer
                title={<>
                    <span style={{ color: "#ff8000", fontWeight: "300" }}>
                        {data.find(x => x[0] === "Overall")[2]}&nbsp;
                    </span>
                    <span>PREMIUMS BOUND</span>
                </>}
                subtitle={<>
                    <span style={{ color: "#ff8000", fontWeight: "300" }}>
                        {data.find(x => x[0] === "Overall")[1]}&nbsp;
                    </span>
                    <span>Average Premiums Bound</span>
                </>}
                loading={loading}
                fixedColumns={1}
                style={{
                    Table: {
                        FixedColumn: { backgroundColor: "none" }
                    }
                }}
                headers={headers}
                rows={data.filter(x => x[0] !== "Overall")}
                exportName="PremiumsBound"
            />
        </div>
    );
}
